// Your web app's Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyCIFVri7awTXgrcXondBLDHfVjNv0NFVOY",
  authDomain: "socialapp-781d3.firebaseapp.com",
  databaseURL: "https://socialapp-781d3.firebaseio.com",
  projectId: "socialapp-781d3",
  storageBucket: "socialapp-781d3.appspot.com",
  messagingSenderId: "273221576086",
  appId: "1:273221576086:web:6c197e86202aba093ce9b7"
};